import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, FormControl, FormArray, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

import { Lead } from '../../../../../shared/lead';
import { PostLead } from '../../../../../shared/post-lead';
import { FormResponse } from '../../../../../shared/form-response';
import { leadValues } from '../../../../../services/lead-values.service';
import { FruHttpService } from '../../../../../services/fru-http.service';
import { JornayaService } from '../../../../../services/jornaya.service';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'consent-form',
  templateUrl: './consent-form.component.html',
  styleUrls: ['./consent-form.component.scss']
})

export class ConsentFormComponent implements OnInit {
  private _availableSelected = {
    lead_id: 0,
    max_prompt: 0,
    status: '',
    lenders: []
  };
  @Input() lead: Lead;
  @Input() selectedEnabled: boolean;
  @Input() encryptedLeadId: string;
  // @Input() availableSelected;
  @Input() set availableSelected(_availableSelected) {
    this._availableSelected = _availableSelected;
  }

  public showPrompt: boolean = false;
  public promptAsked: boolean = false;
  public promptAllowed: boolean = false;
  public isPromptFinished: boolean = false;
  public promptDiplayedLender;
  public promptStep: number = 0;

  public leadForm: UntypedFormGroup;
  public leadValues: Object;
  public phoneMask: Object = {
    mask: '(#00) 000-0000',
    definitions: {'#': /[1-9]/},
    lazy: false
  }
  public zipMask: Object = {
    mask: '00000', 
    lazy: false
  }
  public disableSubmit: boolean = false;
  public buyingProcessControl;
  public veteranMilitaryControl;
  public zipCodeControl;
  public firstNameControl;
  public lastNameControl;
  public emailControl;
  public phoneControl;
  redirectTries: number = 0;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private fruHttp: FruHttpService,
    private elRef:ElementRef,
    private jornayaService: JornayaService,
    private deviceService: DeviceDetectorService,
  ) {
    this.leadValues = leadValues;
  }

  get availableSelected() {
    return this._availableSelected;
  }

  ngOnInit() {
  	this.buildForm();
  }

  buildForm() {
    // Adjust some numbers that might not exactly match the form dropdown
    let purchasePrice = this.getClosestValue(this.lead.purchasePrice, leadValues.purchasePrices);
    let cashOut = this.getClosestValue(this.lead.cashOut, leadValues.cashOuts);
    let propertyValue = this.getClosestValue(this.lead.propertyValue, leadValues.propertyValues);
    let firstMortgageBalance = this.getClosestValue(this.lead.firstMortgageBalance, leadValues.firstMortgageBalances);

    // Figure out what the buying process dropdown should be showing
    let buyingProcess = 'just_thinking';
    if (this.lead.signedAgreement === 'yes') {
      buyingProcess = 'signed_agreement';
    } else if (this.lead.foundHome === 'yes') {
      buyingProcess = 'found_home';
    } else if (this.lead.daysFromBuying === 'yes') {
      buyingProcess = 'days_from_buying';
    }

    // Set up form
    this.leadForm = this.formBuilder.group({
      encryptedLeadId: this.formBuilder.control(this.encryptedLeadId),
      rateType: this.formBuilder.control(this.lead.rateType),
      propertyType: this.formBuilder.control(this.lead.propertyType),
      propertyUse: this.formBuilder.control(this.lead.propertyUse),
      creditRating: this.formBuilder.control(this.lead.creditRating),
      zipCode: this.formBuilder.control(this.lead.zipCode), // , [Validators.required, Validators.pattern(/^(\d{5})$/)]
      veteranMilitary: this.formBuilder.control(this.lead.veteranMilitary),
      firstName: this.formBuilder.control(this.lead.firstName, [Validators.required, Validators.minLength(2)]),
      lastName: this.formBuilder.control(this.lead.lastName, [Validators.required, Validators.minLength(2)]),
      email: this.formBuilder.control(this.lead.email), // , [Validators.required, Validators.email]
      phone: this.formBuilder.control(this.lead.phone, [Validators.required, Validators.pattern(/(\(\d{3}\) \d{3}-\d{4})|\d{10}/)])
    });

    this.leadForm.addControl('formVersion', new UntypedFormControl('consent-form'));

    // Type specific fields
    switch(this.lead.type) {
      case 'purchase':
        this.leadForm.addControl('purchasePrice', this.formBuilder.control(purchasePrice));
        this.leadForm.addControl('downPayment', this.formBuilder.control(this.lead.downPayment));
        this.leadForm.addControl('buyingProcess', this.formBuilder.control(buyingProcess));
        this.leadForm.addControl('daysFromBuying', this.formBuilder.control(this.lead.daysFromBuying));
        this.leadForm.addControl('foundHome', this.formBuilder.control(this.lead.foundHome));
        this.leadForm.addControl('signedAgreement', this.formBuilder.control(this.lead.signedAgreement));
        break;
      case 'refinance':
        this.leadForm.addControl('cashOut', this.formBuilder.control(cashOut));
        this.leadForm.addControl('propertyValue', this.formBuilder.control(propertyValue));
        this.leadForm.addControl('firstMortgageBalance', this.formBuilder.control(firstMortgageBalance));
        this.leadForm.addControl('currentFHA', this.formBuilder.control(this.lead.currentFHA));
        this.leadForm.addControl('currentVA', this.formBuilder.control(this.lead.currentVA));
        break;
    }

    // Controls for use in view
    this.buyingProcessControl = this.leadForm.get('buyingProcess');
    this.veteranMilitaryControl = this.leadForm.get('veteranMilitary');
    this.zipCodeControl = this.leadForm.get('zipCode');
    this.firstNameControl = this.leadForm.get('firstName');
    this.lastNameControl = this.leadForm.get('lastName');
    this.emailControl = this.leadForm.get('email');
    this.phoneControl = this.leadForm.get('phone');

    if (this.selectedEnabled) {
      this.leadForm.addControl('lendersList', new FormArray([]));
      this.leadForm.addControl('lenders', new FormArray([]));
      this.leadForm.addControl('lenders_prompt', new FormArray([]));
      this.leadForm.addControl('selected_tcpa', new UntypedFormControl('1'));
      this.leadForm.addControl('selectedListSource', new UntypedFormControl('selected_manager'));
    }
  }

  ngOnChanges() {
    if (this.availableSelected.lenders.length > 0) {

      if (this.availableSelected.status == 'default_angular_empty_response'
        || this.availableSelected.status == 'default_angular_no_response'
      ) {
        this.leadForm.controls.selectedListSource.setValue(this.availableSelected.status)
      }

      const lenderArray: FormArray = this.leadForm.get('lenders') as FormArray;
      const lenderArrayPrompt: FormArray = this.leadForm.get('lenders_prompt') as FormArray;
      const lenderList: FormArray = this.leadForm.get('lendersList') as FormArray;

      this.promptAllowed = true;

      this.availableSelected.lenders.forEach(value => {
        if (value.checked) {
          lenderArray.push(new UntypedFormControl(value?.id));
          lenderArrayPrompt.push(new UntypedFormControl(value?.id));
        }
        lenderList.push(new UntypedFormControl(value));
      });
    }
  }

  onSubmitForm() {
    this.disableSubmit = true;

    // If this is mobile, slow down
    if (this.deviceService.isMobile()) {
      let seconds = this.jornayaService.secondsSinceLoaded();

      if (seconds === null) {
        if (++this.redirectTries <= 6) {
          // Wait for Jornaya
          setTimeout(function() {
            this.onSubmitForm();
          }.bind(this), 500);
        }
      } else {
        // let waitTime = 1 - seconds;
        // if (waitTime < 0) {
        //   waitTime = 0;
        // }
        // console.log('waiting', waitTime);
        // setTimeout(() => {
            this.submitForm();
        // }, waitTime * 1000);
      }
    } else {
      this.submitForm();
    }
  }

  submitForm() {
    let checkedList = [];
    if (this.selectedEnabled) {
      // Check is all unchecked
      this.leadForm.value.lendersList.forEach(value => {
        if (value.checked) {
          checkedList.push(value.id);
        }
      });
    }

    let isAllDeSelected = false;
    if (this.selectedEnabled
      && this.leadForm.value.lendersList.length > 0
      && checkedList.length == 0
      // && this.availableSelected.max_prompt > 0
      && this.availableSelected.max_prompt > this.promptStep
    ) {
      isAllDeSelected = true

      this.initPrompt(1);
      this.showPrompt = true;
      this.promptAsked = true;

    } else {

      // Get injected elements from tracking scripts
      let trustedForm = this.elRef.nativeElement.querySelector('[name=xxTrustedFormCertUrl]');
      this.lead.trusted_form_cert_url = (trustedForm !== null) ? trustedForm.value : null;

      // const experimentStuff = this.experimentService.forPost();
      // this.lead.experiment = experimentStuff.experiment;
      // this.lead.experiment_variation = experimentStuff.variation;

      let leadId = this.elRef.nativeElement.querySelector('[name=universal_leadid]');
      this.lead.universal_leadid = (leadId !== null) ? leadId.value : null;

      // Assign form values
      this.lead = Object.assign(this.lead, this.leadForm.value);

      // Strip things from phone
      this.lead.phone = this.lead.phone.replace(/[^\d]/g, '').slice(0, 10);



      // Submit the lead
      let postLead = new PostLead(this.lead);
      this.fruHttp.submitConsent(postLead)
        .subscribe(response => {
          this.handleResponse(response);
        });
    }
  }

  getClosestValue(goal: number, numbers: any[]) {
    // Assuming 'numbers' will be one of the key/value array of objects for form values
    let values = [];
    for (let k in numbers) {
      values.push(numbers[k].key);
    }

    let closest = values.reduce((prev, curr) => Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev);

    return closest;
  }

  handleResponse(response: FormResponse) {
    // Watch for malformed response
    if (typeof response.status === 'undefined' || !response.status) {
      this.fruHttp.redirectOffers(this.lead);
      return;
    }

    switch (response.status) {
      case 'New':
      case 'Sent':
      case 'Block':
      case 'Review':
      case 'Not Sendable':
        // Go to thank you page
        this.fruHttp.redirectThankYou(this.lead, response);
        break;

      default:
        // Go to offers page
        this.fruHttp.redirectOffers(this.lead);
        break;
    }
  }

  buyingProcessChange() {
    switch(this.buyingProcessControl.value) {
      case 'days_from_buying':
        this.leadForm.controls['daysFromBuying'].setValue('yes');
        break;
      case 'found_home':
        this.leadForm.controls['daysFromBuying'].setValue('yes');
        this.leadForm.controls['foundHome'].setValue('yes');
        break;
      case 'signed_agreement':
        this.leadForm.controls['daysFromBuying'].setValue('yes');
        this.leadForm.controls['foundHome'].setValue('yes');
        this.leadForm.controls['signedAgreement'].setValue('yes');
        break;
    }
  }

  initPrompt(step) {
    this.promptStep = step;
    console.log(this.promptStep);
    this.promptDiplayedLender = this.availableSelected.lenders[this.promptStep - 1];

    // this.availableSelected.lenders[this.promptStep - 1].prompt_checked = true;
    this.availableSelected.lenders[this.promptStep - 1].prompt_displayed = true;
    this.availableSelected.lenders[this.promptStep - 1].prompt_active = true;

  }

  continueWith(answer = 'no') {
    this.availableSelected.lenders[this.promptStep - 1].checked = answer == 'yes' ? true : false;
    this.availableSelected.lenders[this.promptStep - 1].prompt_checked = answer == 'yes' ? true : false;

    // Update form values based on lender object
    const lenderArray: FormArray = this.leadForm.get('lenders') as FormArray;
    const lenderArrayPrompt: FormArray = this.leadForm.get('lenders_prompt') as FormArray;
    const lenderList: FormArray = this.leadForm.get('lendersList') as FormArray;

    // Clean FormArrays
    lenderArray.clear();
    lenderArrayPrompt.clear();
    lenderList.clear();

    this.availableSelected.lenders.forEach(value => {
      if (value.checked) {
        lenderArray.push(new UntypedFormControl(value?.id));
        lenderArrayPrompt.push(new UntypedFormControl(value?.id));
      }
      lenderList.push(new UntypedFormControl(value));
    });

    setTimeout(() => {
      this.availableSelected.lenders[this.promptStep - 1].prompt_active = false;
      if (this.promptStep < this.availableSelected.max_prompt) {
        this.initPrompt(this.promptStep + 1);
        return;
      } else {
        this.isPromptFinished = true;
        this.submitForm();
      }
    }, 400);
  }

  onCheckChange(event) {
    // this.snap();
    // this.jornayaService.snap(); // need check it

    let lenderUp = [];
    const lenderList: FormArray = this.leadForm.get('lendersList') as FormArray;
    lenderList.controls.forEach((ctrl: UntypedFormControl) => {
      if (event.target.value == ctrl.value.id) {
        if (event.target.checked) {
          ctrl.value.checked = true;
        } else {
          ctrl.value.checked = false;
        }
      }
      lenderUp.push(ctrl.value);
    });

    while (lenderList.length !== 0) {
      lenderList.removeAt(0)
    }

    lenderUp.forEach((lender) => {
      lenderList.push(new UntypedFormControl(lender));
    });

    let i: number = 0;
    const lenderArray: FormArray = this.leadForm.get('lenders') as FormArray;
    if(event.target.checked){
      lenderArray.push(new UntypedFormControl(event.target.value));
    } else {
      let i: number = 0;
      lenderArray.controls.forEach((ctrl: UntypedFormControl) => {
        if(ctrl.value == event.target.value) {
          lenderArray.removeAt(i);
          return;
        }

        i++;
      });
    }
  }

  updateCheckboxes(is_checked, value) {
    let lenderUp = [];
    const lenderList: FormArray = this.leadForm.get('lendersList') as FormArray;
    lenderList.controls.forEach((ctrl: UntypedFormControl) => {
      if (value == ctrl.value.id) {
        if (is_checked) {
          ctrl.value.checked = true;
        } else {
          ctrl.value.checked = false;
        }
      }
      lenderUp.push(ctrl.value);
    });

    while (lenderList.length !== 0) {
      lenderList.removeAt(0)
    }

    lenderUp.forEach((lender) => {
      lenderList.push(new UntypedFormControl(lender));
    });

    let i: number = 0;
    const lenderArray: FormArray = this.leadForm.get('lenders') as FormArray;
    if (is_checked){
      lenderArray.push(new UntypedFormControl(value));
    } else {
      let i: number = 0;
      lenderArray.controls.forEach((ctrl: UntypedFormControl) => {
        if(ctrl.value == value) {
          lenderArray.removeAt(i);
          return;
        }

        i++;
      });
    }
  }

}
